export enum ProjectValidationCodes {
  NOT_A_CUSTOMER_MODULE = 0,
  NO_CONFIGURATION = 1,
  OPEN_CONNECTION = 2,
  NO_IP_ADRESS = 3,
  NO_MODULE = 4,
}
